import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { Router, RouterModule } from '@angular/router'
import { MatExpansionModule } from '@angular/material/expansion'

import { TranslationService } from '../../../services/translation.service'
import { ProductSharingTemplateListComponent } from './product-sharing-template-list/product-sharing-template-list.component'

@Component({
  selector: 'app-product-sharing-templates',
  imports: [
    RouterModule,
    MatExpansionModule,
    ProductSharingTemplateListComponent,
  ],
  templateUrl: './product-sharing-templates.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './product-sharing-templates.component.scss',
})
export class ProductSharingTemplatesComponent {
  translationService = inject(TranslationService)
  router = inject(Router)

  goToCreate(): void {
    this.router.navigate(['settings', 'product-sharing-csv-templates'])
  }
}
